// src/ReservationRequests.jsx

import React, { useEffect, useState } from 'react';
import api from './services/api'; // استيراد ملف API الموحد (axios)

export default function ReservationRequests() {
  const [requests, setRequests] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get('/reservations')
      .then((res) => {
        setRequests(res.data);
        setError(false);
      })
      .catch((err) => {
        console.error('خطأ:', err);
        setError(true);
      });
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">📌 طلبات الحجز</h1>

      {error ? (
        <p className="text-red-600 font-semibold">
          ❌ فشل في تحميل طلبات الحجز.
        </p>
      ) : requests.length === 0 ? (
        <p className="text-gray-600">لا توجد طلبات حجز حاليًا.</p>
      ) : (
        <ul className="space-y-4">
          {requests.map((req, index) => (
            <li
              key={index}
              className="bg-white rounded-lg shadow p-4 border border-gray-300"
            >
              <p><strong>📚 الكتاب:</strong> {req.book?.title || '—'}</p>
              <p><strong>👤 المستخدم:</strong> {req.user?.name || '—'}</p>
              <p><strong>📅 التاريخ:</strong> {new Date(req.createdAt).toLocaleString()}</p>
              <p><strong>⚙️ الحالة:</strong> {req.status}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
